import React from 'react';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { ValuePropsSection } from '../components/ValuePropsSection';
import { ServicesSection } from '../components/ServicesSection';
import { WhyChooseUsSection } from '../components/WhyChooseUsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { PricingSection } from '../components/PricingSection';
import { ServiceAreaSection } from '../components/ServiceAreaSection';
import { CTABannerSection } from '../components/CTABannerSection';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <div className="w-full min-h-screen" style={{
    fontFamily: 'Inter, sans-serif'
  }} data-id="element-287">
      <Navbar data-id="element-288" />
      <main data-id="element-289">
        <HeroSection data-id="element-290" />
        <ValuePropsSection data-id="element-291" />
        <ServicesSection data-id="element-292" />
        <WhyChooseUsSection data-id="element-293" />
        <TestimonialsSection data-id="element-294" />
        <PricingSection data-id="element-295" />
        <ServiceAreaSection data-id="element-296" />
        <CTABannerSection data-id="element-297" />
      </main>
      <Footer data-id="element-298" />
    </div>;
}